import OktaLogo from './okta_logo.png'
import Background from './background.svg'

export const images = {
  Background,
  OktaLogo
}
